<template>
  <!-- 邀请登录 -->
  <div class="card_box">
    <Card>
      <div slot="title" class="titlebox">
        <span class="title">{{ $t('label.SupplierAddApply.Invitation') }}</span>
        <Icon type="ios-create-outline" class="applyicon" />
      </div>

      <Form ref="formdata" :model="formdata" :rules="rules">
        <table class="form-table form-table-print">
          <tr>
            <!-- 供应商名称 -->
            <th class="requiredIitm">{{ $t('label.SupplierAddApply.SupplierName') }}</th>
            <td colspan="5">
              <Form-item prop="supplierName">
                <Input type="text" v-model="formdata.supplierName" :disabled="permission.supplierName!=='w'"/>
              </Form-item>
            </td>
          </tr>

          <tr>
            <!-- 供应商联系人 -->
            <th class="requiredIitm">{{ $t('label.SupplierAddApply.SupplierContact') }}</th>
            <td>
              <Form-item prop="contact">
                <Input type="text" v-model="formdata.contact" :disabled="permission.contact!=='w'" />
              </Form-item>
            </td>
            <!-- 供应商邮件地址 -->
            <th class="requiredIitm">{{ $t('label.SupplierAddApply.SupplierEmail') }}</th>
            <td>
              <Form-item prop="mailAddress">
                <Input type="text" v-model="formdata.mailAddress" :disabled="permission.contact!=='w'" />
              </Form-item>
            </td>
            <!-- 供应商联系电话 -->
            <th class="requiredIitm">{{ $t('label.SupplierAddApply.SupplierPhone') }}</th>
            <td>
              <Form-item prop="telNo">
                <Input type="text" v-model="formdata.telNo" :disabled="permission.contact!=='w'" />
              </Form-item>
            </td>
          </tr>

          <tr>
            <!-- 申请者编号 -->
            <th class="requiredIitm">{{ $t('label.SupplierAddApply.ApplicantId') }}</th>
            <td>
              <Form-item prop="applId">
                <Input type="text" v-model="formdata.applId" disabled/>
              </Form-item>
            </td>
            <!-- 申请者姓名 -->
            <th class="requiredIitm">{{ $t('label.SupplierAddApply.Applicant') }}</th>
            <td>
              <Form-item prop="applName">
                <Input type="text" v-model="formdata.applName" disabled/>
              </Form-item>
            </td>
            <!-- 申请部门 -->
            <th class="requiredIitm">{{ $t('label.SupplierAddApply.ApplyDept') }}</th>
            <td>
              <Form-item prop="applDepartmentId" v-if="permission.contact==='w'">
                <Select v-model="formdata.applDepartmentId" :disabled="permission.contact!=='w'">
                  <Option
                    v-for="item in this.department"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</Option>
                </Select>
              </Form-item>
             <Form-item prop="applyDepartment" v-if="permission.contact!=='w'">
                <Input type="text" v-model="formdata.applyDepartment" disabled/>
              </Form-item>
            </td>
          </tr>

          <tr>
            <!-- 制裁实体 -->
            <th class="requiredIitm">{{$t('label.SupplierApply.SanctionsEntity')}}</th>
            <td style="text-align:left;">
              <Form-item prop="isIran">
                <RadioGroup v-model="formdata.isIran" @on-change="isIranChange">
                  <Radio :disabled="permission.contact!=='w'" label="0">{{ $t('label.SupplierAddApply.yes') }}</Radio>
                  <Radio :disabled="permission.contact!=='w'" label="1">{{ $t('label.SupplierAddApply.no') }}</Radio>
                </RadioGroup>
              </Form-item>
            </td>
            <!-- 发起理由 -->
            <th class="requiredIitm">{{ $t('label.SupplierApply.SearchUrl') }}</th>
            <td style="text-align:left;" colspan="3">
              <div style="padding:0px 5px;">
                <span>美国：</span>
                <a href="https://sanctionssearch.ofac.treas.gov/" target="_blank">{{'https://sanctionssearch.ofac.treas.gov/'}}</a>
              </div>
              <div style="padding:0px 5px;">
                <span>日本：</span>
                <a href="https://www.meti.go.jp/policy/anpo/law05.html#user-list" target="_blank">{{'https://www.meti.go.jp/policy/anpo/law05.html#user-list'}}</a>
              </div>
            </td>
          </tr>

          <tr>
            <!-- 保密协定 -->
            <th class="requiredIitm">{{ $t('label.SupplierAddApply.SupplierIsNda') }}</th>
            <td style="text-align:left;">
              <Form-item prop="isNda">
                <RadioGroup v-model="formdata.isNda">
                  <Radio :disabled="permission.contact!=='w'" label="0">{{ $t('label.SupplierAddApply.yes') }}</Radio>
                  <Radio :disabled="permission.contact!=='w'" label="1">{{ $t('label.SupplierAddApply.no') }}</Radio>
                </RadioGroup>
              </Form-item>
            </td>
            <th class="requiredIitm">{{ $t('label.SupplierApply.InvitationReason') }}</th>
            <td colspan="7">
              <Form-item prop="content">
                <Input v-model="formdata.content" type="textarea" :rows="4" :disabled="permission.contact!=='w'"></Input>
              </Form-item>
            </td>
          </tr>
        </table>
        <Modal
          v-model="modal_flg"
          :title="$t('label.SupplierAddApply.Warning')"
          @on-cancel="colose"
          @on-ok="onOk"
        >
          <p>{{ $t('ERR.SupplierAdd.003') }}</p>
        </Modal>
      </Form>
    </Card>
  </div>
</template>
<script>
import util from '@/libs/util';
export default {
  data() {
    return {
      //applyDepartmentName: "",
      formdata:{},
      detail: false,
      modal_flg: false,
      department: [],
      rules: {
        supplierName: [
          // 请输入供应商名称
          { required: true, message: util.getmsg(this,'label.SupplierAddApply.SupplierName'), trigger: "change" }
        ],
        contact: [
          {
            // 请输入供应商联系人
            required: true,
            message: util.getmsg(this,'label.SupplierAddApply.SupplierContact'),
            trigger: "change"
          }
        ],
        // applDepartmentId: [
        //   { required: true, message: "申请部门不能为空", trigger: "change" }
        // ],
        mailAddress: [
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              //请输入供应商邮箱地址
              if (!value) {
                callback(util.getmsg(this,'label.SupplierAddApply.SupplierEmail'));
              } else if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback($t("label.SupplierAddApply.SupplierEmail") + $t("ERR-00"));
              } else {
                callback();
              }
            }
          }
        ],
        isNda: [
          {
            // 请输入仅用于保密协议签订
            required: true,
            message: util.getmsg(this,'label.SupplierAddApply.SupplierIsNda'),
            trigger: "change"
          }
        ],
        telNo: [
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!value) {
                // 请输入供应商联系电话
                callback(util.getmsg(this,'label.SupplierAddApply.SupplierPhone'));
              } else if (!/^[\d\-]+$/.test(value)) {
                //供应商联系电话不正确
                callback($t("label.SupplierAddApply.SupplierPhone") + $t("ERR-00"));
              } else {
                callback();
              }
            }
          }
        ],
        isIran: [
          //请输入制裁实体
          { required: true, message: util.getmsg(this,'label.SupplierApply.SanctionsEntity'), trigger: "change" }
        ],
        content: [
          {
            // 请输入发起理由(购买/委托内容)不能为空
            required: true,
            message: util.getmsg(this,'label.SupplierApply.InvitationReason'),
            trigger: "change"
          }
        ]
      }
    };
  },
  props: {
    parent: {
      //默认数据
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  created() {
    this.formdata = this.parent.data.gysywb;
    this.permission = this.parent.permission.gysywb.TSUPPLIERAPPLY;
    this.getDepartment();
    this.detail = !this.$parent.instance ? false : this.$parent.instance.status === "end" || this.$parent.instance.status === "running" || this.$parent.instance.status === "manualend" ? true : this.$parent.instance.status === "draft" ? false : false;
    if (!this.detail) {
      if(!this.formdata.contact){this.$set(this.formdata, "contact", "");}
      if(!this.formdata.content){this.$set(this.formdata, "content", "");}
      if(!this.formdata.isIran){this.$set(this.formdata, "isIran", "");}
      if(!this.formdata.isNda){this.$set(this.formdata, "isNda", "");}
      if(!this.formdata.mailAddress){this.$set(this.formdata, "mailAddress", "");}
      if(!this.formdata.supplierName){this.$set(this.formdata, "supplierName", "");}
      if(!this.formdata.telNo){this.$set(this.formdata, "telNo", "");}
    }
  },
  methods: {
    //表单提交
    // formdata
    // formDynamic
    // formService
    handleSubmit() {
      var that = this;
      var check = async function getVaild() {
        var validateflg = false;
        var validate_a = await that.abHttpUtil
          .post('/supplierAddApply/supplierCheck?supplierName='+that.formdata.supplierName,{})
          .then((res) =>{
            return res === 0 ? true : false;
          })

        that.$refs.formdata.validate(valid => {
          if (valid && validate_a) {
            validateflg = true;
            Object.assign(that.$parent.data.gysywb, that.formdata);
          } else {
            var list = []
            if (!validate_a) { list.push($t('ERR.SupplierAdd.002')); }
            that.errmsg(list);
          }
        });
        return validateflg;
      };
      return check();
    },
    isIranChange(e) {
      if (e == 0) {
        this.modal_flg = true;
      }
    },
    onOk() {
      this.formdata.supplierName = "";
      this.formdata.contact = "";
      this.formdata.mailAddress = "";
      this.formdata.isNda = "";
      this.formdata.telNo = "";
      this.formdata.content = "";
      this.formdata.isIran = "";
    },
    colose() {
      this.modal_flg = false;
      this.formdata.isIran = "";
    },
    //校验
    errmsg(custom) {
      this.$nextTick(() => {
        var errMsg = [];
        var errList = document.querySelectorAll(".ivu-form-item-error-tip");
        errList.forEach(val => {
          if (errMsg.indexOf(val.innerHTML) == -1) {
            errMsg.push(val.innerHTML);
          }
        });
        if (custom.length > 0) {
          errMsg = errMsg.concat(custom);
        }
        errMsg.forEach(val => {
          this.$Message.error({content:val,duration: 5});
        });
      });
    },
    getDepartment() {
      this.abHttpUtil.post("/common/department", {}).then(res => {
        const data = res;
        data.forEach(item => {
          this.department.push(item);
        });
        if(this.formdata.applDepartmentId==null){
          this.formdata.applDepartmentId = this.department[0].id;
        }
        this.getapplDepartmentName();
      });
    },
    // getapplDepartmentName(){
    //   this.abHttpUtil.post("/common/getapplDepartmentName?applDepartmentId=" + this.formdata.applDepartmentId, {}).then(res => {
    //       this.applyDepartmentName=res;
    //   });
    // }
  }
};
</script>
